module.exports = __webpack_public_path__ + "66a5c7a1a46061be310aabbda7cff63a.png";